export const multivendor = {
	closings: {
		title: "Cierre por vendor",
		filename: "cierre-de-vendors",
		columns: {
			vendorName: "Vendor",
			vendorValueToReceive: "Valor a recibir",
			otherProductsFeeValue: "Tarifa variable sobre productos especiales",
			generalFeeValue: "Tarifa variable general",
			eventDate: "Fecha del evento",
			payDate: "Fecha de transferencia",
			generalPercentageFee: "Tarifa variable sobre facturación",
			fixedFee: "Tarifa de renta fija",
			totalSoldValue: "Facturación total",
		},
		emptyText: "Sin datos para mostrar.",
	},
	productsSold: {
		title: "Productos vendidos por vendor",
	},
	revenues: {
		title: "Facturación por vendor",
		description:
			"Reporte de relación de facturación y cada vendor registrado como parte del evento.",
		filename: "facturacion_por_vendor",
		columns: {
			name: "Vendor",
			totalSoldValue: "Productos vendidos",
			totalTipValue: "Servicio",
			subtotal: "Subtotal",
			rent: "Renta",
			revenue: "Ingreso",
			singleProductReturns: "Devoluciones individuales",
		},
	},
};
